import { faker } from '@faker-js/faker'

import { UserCancelReservationCommand } from '../../contracts/reservation'
import { asBuilder } from '../asBuilder'

export const cancelReservationCommand = asBuilder<UserCancelReservationCommand>((): UserCancelReservationCommand => {
  return {
    reservationId: faker.number.int(),
    reservationCancelReason: faker.string.uuid(),
    reservationCancelReasonCode: faker.string.uuid(),
  }
})
